"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconSelect = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
function IconSelect(_a) {
    var testId = _a.testId;
    return (react_1.default.createElement("svg", { width: "9", height: "13", viewBox: "0 0 9 13", "data-testid": testId },
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 8.1875H8.25L4.125 13L0 8.1875Z", fill: "currentColor" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 4.8125H8.25L4.125 0L0 4.8125Z", fill: "currentColor" })));
}
exports.IconSelect = IconSelect;
//# sourceMappingURL=icons.js.map